export const currencies = [
    {
        short: "EUR",
        name: "Euro",
        rate: 4.4660,
    },
    {
        short: "GBP",
        name: "Funt brytyjski",
        rate: 4.8851,
    },
    {
        short: "USD",
        name: "Dolar amerykański",
        rate: 3.9806,
    },
    {
        short: "CHF",
        name: "Frank szwajcarski",
        rate: 4.1818,
    },
];